import React from 'react';

export default function TrialSubjectsCatalog({ subjects, protocol, onExport }) {
  return (
    <div>
      {/* Protocol banner */}
      <div style={{
        background: '#e3f2fd', borderRadius: 8, padding: '12px 16px', marginBottom: 16,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
      }}>
        <span style={{ fontWeight: 500 }}>
          {protocol.therapeutic_area} Phase {protocol.phase} · {protocol.arms.length} arms · {subjects.length} subjects
        </span>
        <button
          onClick={onExport}
          style={{
            padding: '6px 16px', borderRadius: 6, border: 'none',
            background: '#1976d2', color: '#fff', cursor: 'pointer', fontWeight: 500
          }}
        >
          Export All (SDTM ZIP)
        </button>
      </div>

      {subjects.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#888' }}>
          No subjects generated yet
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f5f5f5' }}>
              {['USUBJID', 'Arm', 'Age / Sex', 'AEs', 'Disposition'].map(h => (
                <th key={h} style={{ padding: '10px 12px', textAlign: 'left', borderBottom: '2px solid #e0e0e0' }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {subjects.map(s => (
              <tr key={s.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '10px 12px', fontFamily: 'monospace', fontSize: 13 }}>{s.usubjid}</td>
                <td style={{ padding: '10px 12px' }}>{s.arm_id}</td>
                <td style={{ padding: '10px 12px' }}>{s.age} / {s.sex}</td>
                <td style={{ padding: '10px 12px' }}>{(s.sdtm_payload?.AE || []).length}</td>
                <td style={{ padding: '10px 12px' }}>
                  <span style={{
                    padding: '2px 8px', borderRadius: 12, fontSize: 12, fontWeight: 500,
                    background: s.disposition === 'COMPLETED' ? '#e8f5e9' : '#fff3e0',
                    color: s.disposition === 'COMPLETED' ? '#2e7d32' : '#e65100',
                  }}>
                    {s.disposition}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
